(function () {
    'use strict';

    function AddWalletBalanceController($scope, $translate, $mdDialog, $mdToast, WalletService) {

        var $ctrl = this;

        $ctrl.balance = {
            amount: null,
            method: null,
            note: '',
            sourceType: 'MANUAL',
            amountUnit: 'TOMAN'
        };

        $ctrl.addBalance = function () {
            addWalletBalanceByCustomerId($ctrl.balance);
        };

        $ctrl.cancel = function () {
            $mdDialog.cancel();
        };

        function addWalletBalanceByCustomerId(balance) {
            WalletService.addWalletBallanceByCustomerId($ctrl.customerId)
                .save(balance, onSuccess, onError);
        }

        function onSuccess(res) {

            $mdDialog.hide(res);

            $mdToast.show(
                $mdToast.simple()
                    .textContent('افزایش موجودی با موفقیت انجام شد')
                    .position('top left')
                    .hideDelay(4000)
                    .theme('success-toast')
            );
        }

        function onError() {

            $mdDialog.hide();

            $mdToast.show(
                $mdToast.simple()
                    .textContent('خطایی در افزایش موجودی رخ داده است')
                    .position('top left')
                    .hideDelay(4000)
                    .theme('error-toast')
            );
        }
    }

    var AddWalletBalanceComponent = {
        templateUrl: 'app/components/partial-forms/wallet/add-balance-wallet.html',
        controller: AddWalletBalanceController,
        bindings: {
           customerId: '<'
        }
    };

    angular
        .module('tikonApp')
        .component('pfAddWalletBalance', AddWalletBalanceComponent);

    AddWalletBalanceController.$inject = ['$scope', '$translate', '$mdDialog', '$mdToast', 'WalletService'];

})();
